// extracted by mini-css-extract-plugin
module.exports = {"background":"bc_d6","shopping__wrapper__examples":"bc_fh","active":"bc_fj","shopping__wrapper__project":"bc_fk"};